import {RecommendVideo, userVideo, verticalList} from "./model/HomePage";
import HomePageEvents from "./HomePageEvents";
import {AppAction} from "../../root/AppAction";
// import {Video} from "../../stores/program/model/Program";
// import {VideocamSharp} from "@material-ui/icons";

export interface RecommendListStore {
    list: number[];
    videos: {[videoId: number]: RecommendVideo};
    newVideoList: verticalList[];
    recommendVideoList: RecommendVideo[];
    recommendProgramList: verticalList[];
    recommendProfessionalList: verticalList[];
    userVideos: userVideo[];
    isLoading: boolean;
    isUpdateRecVideos: boolean;
    isUpdateFailedRecVideos: boolean;
    isUpdateSuccessRecVideos: boolean;
    isUpdateRecPrograms: boolean;
    isUpdateFailedRecPrograms: boolean;
    isUpdateSuccessRecPrograms: boolean;
    isUpdateRecProfessionals: boolean;
    isUpdateFailedRecProfessionals: boolean;
    isUpdateSuccessRecProfessionals: boolean;
    isReset: boolean;
}

const initialStore: RecommendListStore = {
    list: [],
    videos: [],
    newVideoList:[],
    recommendVideoList: [],
    recommendProgramList:[],
    recommendProfessionalList:[],
    userVideos: [],
    isLoading: false,
    isUpdateRecVideos: false,
    isUpdateSuccessRecVideos: false,
    isUpdateFailedRecVideos: false,
    isUpdateRecPrograms: false,
    isUpdateSuccessRecPrograms: false,
    isUpdateFailedRecPrograms: false,
    isUpdateRecProfessionals: false,
    isUpdateSuccessRecProfessionals: false,
    isUpdateFailedRecProfessionals: false,
    isReset: true
};

function byIdMap(videos: RecommendVideo[]): {[videoId: number]: RecommendVideo} {
    return Object.fromEntries(
        videos.map(video => [video.id, video])
    );
}

export default function recommendList(state: RecommendListStore = initialStore, action: AppAction) {
    switch (action.type) {
        // -----------------------------------------------------------------------------------
        // おすすめビデオ
        // 取得
        case HomePageEvents.GetRecVideoListStarted:
            return {
                ...state,
                isLoading: true
            };
        case HomePageEvents.GetRecVideoListComplete:
            return {
                ...state,
                isLoading: false,
                videos: byIdMap(action.videos),
                recommendVideoList: action.videos,
                list: action.videos.map(({id}: RecommendVideo) => id),
                isReset: false
            };
        // TODO
        case HomePageEvents.GetEditRecVideoListStarted:
            return {
                ...state,
                isLoading: true
            };
        case HomePageEvents.GetEditRecVideoListComplete:
            return {
                ...state,
                isLoading: false,
                recommendVideoList: action.videos
            };
        // 編集
        case HomePageEvents.UpdateRecVideosStarted:
            return {
                ...state,
                isLoading: true,
                isUpdateRecVideos: true,
                isUpdateSuccessRecVideos: false,
                isUpdateFailedRecVideos: false
            };
        case HomePageEvents.UpdateRecVideosComplete:
            return {
                ...state,
                // videos: byIdMap(action.recommendVideoList),
                // list: action.recommendVideoList.map(({id}: RecommendVideo) => id),
                recommendVideoList: action.recommendVideoList,
                isLoading: false,
                isUpdateRecVideos: false,
                isUpdateSuccessRecVideos: true,
                isUpdateFailedRecVideos: false
            };
        case HomePageEvents.UpdateRecVideosFailed:
            return {
                ...state,
                isLoading: false,
                isUpdateRecVideos: false,
                isUpdateSuccessRecVideos: false,
                isUpdateFailedRecVideos: true
            };
        case HomePageEvents.ResetRecVideos:
            return {
                ...state,
                list: [],
                videos: [],
                isReset: true
            };
        // 追加
        case HomePageEvents.AddVideoToRecStarted:
            return {
                ...state,
                isLoading: true
            };
        case HomePageEvents.AddVideoToRecComplete:
            return {
                ...state,
                isLoading: false,
                recommendVideoList: action.recommendVideoList
            };
        // -----------------------------------------------------------------------------------
        // おすすめプログラム
        // 取得
        case HomePageEvents.GetRecommendProgramListStarted:
            return {
                ...state,
                isLoading: true
            };
        case HomePageEvents.GetRecommendProgramListComplete:
            return {
                ...state,
                recommendProgramList: action.recommendProgramList,
                isLoading: false,
                isReset: false
            };
        // 編集
        case HomePageEvents.UpdateRecProgramsStarted:
            return {
                ...state,
                isLoading: true,
                isUpdateRecPrograms: true,
                isUpdateSuccessRecPrograms: false,
                isUpdateFailedRecPrograms: false
            };
        case HomePageEvents.UpdateRecProgramsComplete:
            return {
                ...state,
                recommendProgramList: action.recommendProgramList,
                isLoading: false,
                isUpdateRecPrograms: false,
                isUpdateSuccessRecPrograms: true,
                isUpdateFailedRecPrograms: false
            };

        case HomePageEvents.UpdateRecProgramsFailed:
            return {
                ...state,
                isLoading: false,
                isUpdateRecPrograms: false,
                isUpdateSuccessRecPrograms: false,
                isUpdateFailedRecPrograms: true
            };
        // 追加
        case HomePageEvents.addRecProgramComplete:
            return {
                ...state,
                recommendProgramList: action.recommendProgramList
            };
        // 削除
        case HomePageEvents.delRecProgramComplete:
            return {
                ...state,
                recommendProgramList: action.recommendProgramList
            };
        // -----------------------------------------------------------------------------------
        // おすすめプロフェショナル
        // 取得
        case HomePageEvents.GetRecommendProfessionalListStarted:
            return {
                ...state,
                isLoading: true
            };

        case HomePageEvents.GetRecommendProfessionalListComplete:
            return {
                ...state,
                recommendProfessionalList: action.recommendProfessionalList,
                isLoading: false,
                isReset: false
            };
        // 編集
        case HomePageEvents.UpdateRecProfessionalsStarted:
            return {
                ...state,
                isLoading: true,
                isUpdateRecProfessionals: true,
                isUpdateSuccessRecProfessionals: false,
                isUpdateFailedRecProfessionals: false
            };
        case HomePageEvents.UpdateRecProfessionalsComplete:
            return {
                ...state,
                recommendProfessionalList: action.recommendProfessionalList,
                isLoading: false,
                isUpdateRecProfessionals: false,
                isUpdateSuccessRecProfessionals: true,
                isUpdateFailedRecProfessionals: false
            };
        case HomePageEvents.UpdateRecProfessionalsFailed:
            return {
                ...state,
                isLoading: false,
                isUpdateRecProfessionals: false,
                isUpdateSuccessRecProfessionals: false,
                isUpdateFailedRecProfessionals: true
            };
        // 追加
        case HomePageEvents.addRecProfessionalComplete:
            return {
                ...state,
                recommendProfessionalList: action.recommendProfessionalList
            };
        // 削除
        case HomePageEvents.removeRecProfessionalComplete:
            return {
                ...state,
                recommendProfessionalList: action.recommendProfessionalList
            };

        // -----------------------------------------------------------------------------------
        // 新着ビデオ
        // 取得
        case HomePageEvents.GetNewVideoListStarted:
            return {
                ...state,
                isLoading: true
            };
        case HomePageEvents.GetNewVideoListComplete:
            return {
                ...state,
                newVideoList: action.newVideoList,
                isLoading: false
            };

        // -----------------------------------------------------------------------------------
        // ユーザー視聴履歴
        // 取得
        case HomePageEvents.GetVideoListByUserStarted:
            return {
                ...state,
                isLoading: true
            };
        case HomePageEvents.GetVideoListByUserComplete:
            return {
                ...state,
                isLoading: false,
                userVideos: action.userVideos
            };
        case HomePageEvents.ResetUserVideos:
            return {
                ...state,
                isLoading: false,
                userVideos: []
            };

        default:
            return state;
    }
}
